export default __webpack_public_path__ + "static/media/family3.68a6329c.jpg";